interface HeaderTitleInput {
  currentTopicNo?: string;
  topicTitle?: string;
  historyTopicNo?: string;
  historyTopicName?: string;
  fallbackTitle?: string;
}

interface RefreshTopicTitleInput {
  previousTopicNo?: string;
  currentTopicNo?: string;
}

interface GeneratedTitleUpdateInput {
  topicNo?: string;
  topicName?: string;
}

interface GeneratedTitleUpdate {
  topicNo: string;
  title: string;
}

export function shouldRefreshTopicTitle({
  previousTopicNo,
  currentTopicNo,
}: RefreshTopicTitleInput) {
  return Boolean(previousTopicNo && currentTopicNo && previousTopicNo !== currentTopicNo);
}

export function getHeaderTitle({
  currentTopicNo,
  topicTitle,
  historyTopicNo,
  historyTopicName,
  fallbackTitle = "",
}: HeaderTitleInput) {
  if (historyTopicName && (!currentTopicNo || !historyTopicNo || historyTopicNo === currentTopicNo)) {
    return historyTopicName;
  }

  return topicTitle || fallbackTitle;
}

export function getGeneratedTitleUpdate({
  topicNo,
  topicName,
}: GeneratedTitleUpdateInput): GeneratedTitleUpdate | null {
  const title = topicName?.trim();

  if (!topicNo || !title) return null;

  return {
    topicNo,
    title,
  };
}

export const getFetchedTopicTitleUpdate = getGeneratedTitleUpdate;

export function getTitleChangePayload({
  topicNo,
  title,
}: GeneratedTitleUpdate): GeneratedTitleUpdate | null {
  return getGeneratedTitleUpdate({
    topicNo,
    topicName: title,
  });
}
